var SupportGetawaysBookingStatusAndNotesPresentation;

SupportGetawaysBookingStatusAndNotesPresentation = {
  editable: {
    status: "Booked",
    notes: "You can cancel this reservation anytime before cancellation date listed in fine print."
  },
  not_editable: {
    available: {
      status: "Booked",
      notes: ""
    },
    non_cancellable: {
      status: "Booked",
      notes: "You may no longer edit this booking because the cancellation window has passed"
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Reservation has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Reservation has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Reservation has passed",
      notes: ""
    }
  }
};

module.exports = SupportGetawaysBookingStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c19ib29raW5nX21lc3NhZ2VzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvZ2V0YXdheXNfYm9va2luZ19tZXNzYWdlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxnREFBQSxHQUNDO0VBQUEsUUFBQSxFQUNDO0lBQUEsTUFBQSxFQUFRLFFBQVI7SUFDQSxLQUFBLEVBQVEsd0ZBRFI7R0FERDtFQUdBLFlBQUEsRUFDQztJQUFBLFNBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxRQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FERDtJQUdBLGVBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxRQUFSO01BQ0EsS0FBQSxFQUFPLGdGQURQO0tBSkQ7SUFNQSxRQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsMERBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQVBEO0lBU0EsT0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLHdCQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FWRDtJQVlBLGdCQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsd0JBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQWJEO0lBZUEsa0JBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSx3QkFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBaEJEO0dBSkQ7OztBQXVCRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
